import { createTheme } from "react-data-table-component";

let themesRegistered = false;

const lightThemeConfig = {
  text: {
    primary: "#212529",
    secondary: "#6c757d",
  },
  background: {
    default: "transparent",
  },
  context: {
    background: "#e3f2fd",
    text: "#213f7f",
  },
  divider: {
    default: "rgba(0,0,0,0.08)",
  },
  action: {
    button: "rgba(0,0,0,0.54)",
    hover: "rgba(0,0,0,0.08)",
    disabled: "rgba(0,0,0,0.12)",
  },
};

const darkThemeConfig = {
  text: {
    primary: "#f8f9fa",
    secondary: "#adb5bd",
  },
  background: {
    default: "transparent",
  },
  context: {
    background: "#1f2c40",
    text: "#f8f9fa",
  },
  divider: {
    default: "rgba(255,255,255,0.08)",
  },
  action: {
    button: "rgba(255,255,255,0.7)",
    hover: "rgba(255,255,255,0.08)",
    disabled: "rgba(255,255,255,0.12)",
  },
};

export const ensureVelzonDataTableThemes = () => {
  if (themesRegistered) {
    return;
  }
  createTheme("velzonLight", lightThemeConfig, "light");
  createTheme("velzonDark", darkThemeConfig, "dark");
  themesRegistered = true;
};

export type DataTableThemeMode = "light" | "dark";

export const buildVelzonDataTableStyles = (mode: DataTableThemeMode) => {
  const isDark = mode === "dark";
  const textColor = isDark ? "#f8f9fa" : "#212529";
  const headBackground = isDark ? "rgba(17, 24, 39, 0.95)" : "rgba(0,0,0,0.03)";
  const rowBorderColor = isDark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)";
  const hoverBackground = isDark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.05)";
  const paginationBackground = isDark ? "rgba(17, 24, 39, 0.9)" : "rgba(0,0,0,0.02)";
  const baseBackground = isDark ? "rgba(15, 23, 42, 0.85)" : "#fff";
  const rowBackground = isDark ? "rgba(15, 23, 42, 0.65)" : "#fff";
  return {
    table: {
      style: {
        backgroundColor: baseBackground,
        color: textColor,
        borderRadius: "0.5rem",
      },
    },
    headCells: {
      style: {
        backgroundColor: headBackground,
        fontWeight: 600,
        fontSize: "0.85rem",
        color: textColor,
        borderBottomWidth: "1px",
        borderBottomColor: rowBorderColor,
      },
    },
    rows: {
      style: {
        minHeight: "48px",
        color: textColor,
        "&:not(:last-of-type)": {
          borderBottomWidth: "1px",
          borderBottomColor: rowBorderColor,
        },
        backgroundColor: rowBackground,
      },
      stripedStyle: {
        backgroundColor: isDark ? "rgba(255,255,255,0.03)" : "rgba(0,0,0,0.01)",
      },
      highlightOnHoverStyle: {
        backgroundColor: hoverBackground,
        color: textColor,
        transitionDuration: "0.2s",
        outline: "none",
      },
    },
    headRow: {
      style: {
        minHeight: "50px",
      },
    },
    pagination: {
      style: {
        borderTopStyle: "solid" as const,
        borderTopWidth: "1px",
        borderTopColor: rowBorderColor,
        backgroundColor: paginationBackground,
        color: textColor,
      },
      pageButtonsStyle: {
        fill: textColor,
        "&:disabled": {
          fill: isDark ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.3)",
        },
      },
    },
  };
};
